export default function MentionsLegales() {
  const blockStyle = {
    background: 'var(--color-bg-white)',
    borderRadius: 'var(--radius-lg)',
    padding: '2rem 2.25rem',
    border: '1px solid var(--color-border)',
    marginBottom: '1.5rem',
  };

  return (
    <div className="page-content">
      <div className="container" style={{ maxWidth: 800 }}>
        <span className="gold-tag">Légal</span>
        <h1 style={{ marginTop: '0.5rem', marginBottom: '2rem' }}>Mentions légales</h1>

        <div style={blockStyle}>
          <h2>Éditeur du site</h2>
          <p style={{ lineHeight: 1.8, margin: 0 }}>
            <strong>Deal Israel</strong><br />
            Site d'information indépendant sur l'investissement immobilier en Israël.<br />
            Contact : <a href="mailto:contact@deal-israel.com" style={{ color: 'var(--color-accent)' }}>contact@deal-israel.com</a>
          </p>
        </div>

        <div style={blockStyle}>
          <h2>Hébergement</h2>
          <p style={{ lineHeight: 1.8, margin: 0 }}>
            Ce site est hébergé par <strong>Hostinger International Ltd</strong><br />
            61 Lordou Vironos Street, 6023 Larnaca, Chypre<br />
            <a href="https://www.hostinger.fr" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--color-accent)' }}>www.hostinger.fr</a>
          </p>
        </div>

        <div style={blockStyle}>
          <h2>Avertissement — Pas de conseil en investissement</h2>
          <p style={{ lineHeight: 1.8, margin: '0 0 1rem' }}>
            Les informations publiées sur Deal Israel sont fournies à titre <strong>purement informatif et indicatif</strong>. Elles ne constituent pas un conseil en investissement, une recommandation d'achat ou de vente de bien immobilier, ni un conseil fiscal ou juridique.
          </p>
          <p style={{ lineHeight: 1.8, margin: '0 0 1rem' }}>
            Les données de prix, rendements et fiscalité sont indicatives et susceptibles d'évoluer. Elles sont issues de sources publiques (Tabu, CBS Israël, relevés de marché) et ne sauraient engager la responsabilité d'Deal Israel.
          </p>
          <p style={{ lineHeight: 1.8, margin: 0 }}>
            Tout investissement immobilier comporte des risques. Nous vous recommandons de consulter un <strong>avocat israélien agréé</strong> et un <strong>expert-comptable spécialisé</strong> avant toute décision d'acquisition.
          </p>
        </div>

        <div style={blockStyle}>
          <h2>Propriété intellectuelle</h2>
          <p style={{ lineHeight: 1.8, margin: 0 }}>
            L'ensemble du contenu de ce site (textes, analyses, outils de simulation) est la propriété d'Deal Israel. Toute reproduction, même partielle, est interdite sans autorisation préalable écrite.
          </p>
        </div>

        <div style={blockStyle}>
          <h2>Données personnelles (RGPD)</h2>
          <p style={{ lineHeight: 1.8, margin: '0 0 1rem' }}>
            Deal Israel collecte uniquement les données que vous fournissez volontairement via le formulaire de contact (nom, email, téléphone, description du projet). Ces données sont utilisées exclusivement pour répondre à votre demande.
          </p>
          <p style={{ lineHeight: 1.8, margin: '0 0 1rem' }}>
            Vos données ne sont jamais vendues ni transmises à des tiers à des fins commerciales.
          </p>
          <p style={{ lineHeight: 1.8, margin: 0 }}>
            Conformément au Règlement Général sur la Protection des Données (RGPD), vous disposez d'un droit d'accès, de rectification et de suppression de vos données. Pour exercer ce droit : <a href="mailto:contact@deal-israel.com" style={{ color: 'var(--color-accent)' }}>contact@deal-israel.com</a>
          </p>
        </div>

        <div style={blockStyle}>
          <h2>Cookies</h2>
          <p style={{ lineHeight: 1.8, margin: 0 }}>
            Ce site n'utilise pas de cookies de tracking ou publicitaires. Aucune donnée de navigation n'est collectée sans votre consentement.
          </p>
        </div>

        <p style={{ fontSize: '0.8rem', color: 'var(--color-text-muted)', marginTop: '1rem' }}>
          Dernière mise à jour : mars 2025
        </p>
      </div>
    </div>
  );
}
